const Suppliers = {
  YORK_WALLPAPER: 3,
  BIDK_HOME: 8,
  ADVANCED_DIGITAL_TEXTILES: 16,
  SURYA: 21,
  STARK_STUDIO: 23,
  YORK_NON_SCALAMANDRE: 24,
  BUTLER_SPECIALITY_GROUP: 25,
  MOE_S_HOME_COLLECTION: 27,
  STATIONARY_HQ: 28,
  HUDSON_VALLEY_LIGHTING: 29,
  MITZI: 30
};

export default Suppliers;